import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';

import { ToastComponent } from '@core/components/toast/toast.component';
import { UtilsPipeModule } from '@core/pipes/utils-pipe';

@NgModule({
  declarations: [
    ToastComponent,
   
  ],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDividerModule, UtilsPipeModule],
  exports: [ToastComponent]
})

export class BxToastModule { }